// ============================================================
// PORTFOLIO DATA — All content hardcoded from CV & LinkedIn
// ============================================================

export const projects = [
  {
    _id: "p1",
    title: 'Uncertainty-Aware ECG Arrhythmia Detection',
    subtitle: 'Ongoing Research Project',
    description: 'Building CNN ensemble models with MC Dropout uncertainty quantification for ECG arrhythmia detection, deployed via a Streamlit web app. Actively in development as a final-year research project at SLIIT.',
    tags: ['Python', 'TensorFlow', 'Deep Learning', 'Streamlit', 'Research'],
    associatedWith: 'SLIIT',
    githubLink: 'https://github.com/Bijon2002/ECG-Uncertainty-Detection',
    date: 'Feb 2026 – Present',
    order: 1
  },
  {
    _id: "p2",
    title: 'BuyMe — E-Commerce Platform',
    subtitle: 'Live Deployed',
    description: 'Full-stack deployed e-commerce app with product catalog, cart, order management, JWT authentication, RBAC, and admin dashboard. Built with the MERN stack.',
    tags: ['React.js', 'Node.js', 'Express', 'MongoDB', 'JWT'],
    liveLink: 'https://buyme.pages.dev',
    date: 'Jan 2026 – Present',
    order: 2
  },
  {
    _id: "p3",
    title: 'StudyPulse — AI Study Companion',
    subtitle: 'Full-Stack Application',
    description: 'Intelligent study ecosystem with deep focus tracking, collaborative tools, and AI-driven insights. Includes a Chrome Extension with Focus Guardian, Infinity Whiteboard with auto-scaling canvas, AI Study Assistant powered by Pollinations.ai, Global Leaderboard, Study Rooms, and Daily Planner.',
    tags: ['React.js', 'Node.js', 'MongoDB', 'Chrome Ext', 'AI'],
    liveLink: 'https://studypulse.sa24610209.workers.dev/',
    githubLink: 'https://github.com/Bijon2002/StudyPulse',
    date: 'Jan 2026 – Present',
    order: 3
  },
  {
    _id: "p4",
    title: 'RentTent — Boarding Platform',
    subtitle: 'Team Lead · Academic Project',
    description: 'Led development of a boarding platform with NIC-based verification, subscription/commission model, and AI chatbot integration via Botpress. Managed team using Jira with Agile/Scrum methodology. Built with Laravel, PHP, Docker, and Selenium testing.',
    tags: ['Laravel', 'PHP', 'Docker', 'Selenium', 'Jira'],
    associatedWith: 'SLIIT',
    githubLink: 'https://github.com/Bijon2002/RentTent',
    date: 'Jul 2025 – Oct 2025',
    order: 4
  },
  {
    _id: "p5",
    title: 'AI Legal Doc Explainer',
    subtitle: 'Hackathon · CodeStorm.AI',
    description: 'AI-powered solution that simplifies legal documents for everyday users. Summarizes content, highlights key clauses and red flags, and answers context-based queries. Built for CodeStorm.AI Round 1.',
    tags: ['Python', 'NLP', 'AI'],
    date: 'Aug 2025',
    order: 5
  },
  {
    _id: "p6",
    title: 'Vec-Doc — Vehicle Document Tracker',
    subtitle: 'Mobile App',
    description: 'Mobile-first motorbike document & maintenance tracking platform. Features insurance/PUC/license expiry alerts, GPS-based distance tracking, oil change reminders with visual progress, and smart notifications with quiet hours. Built with React Native (Expo) and Node.js/PostgreSQL backend.',
    tags: ['React Native', 'Expo', 'Node.js', 'PostgreSQL', 'Prisma'],
    githubLink: 'https://github.com/Bijon2002/Vec-Doc',
    date: '2026',
    order: 6
  },
  {
    _id: "p7",
    title: 'Duno — Social Media Platform',
    subtitle: 'Full-Stack Application',
    description: 'Full-stack social media platform with JWT auth, posts, likes, follow system, and feed. Organized into 3 launches: MVP core, engagement growth, and smart scalable system with ranking, behavior tracking, real-time chat, and trending detection.',
    tags: ['Next.js', 'Express', 'MongoDB', 'JWT', 'Socket.IO'],
    githubLink: 'https://github.com/Bijon2002/Duno-',
    date: '2026',
    order: 7
  },
  {
    _id: "p8",
    title: 'Banana Brain Quest — Math Puzzle Game',
    subtitle: 'Enterprise Software · Academic',
    description: 'Premium competitive math puzzle game with jungle/gold glassmorphism aesthetic. Features solo arcade, real-time multiplayer via Socket.io, XP ranking system with 10 ranks, badges, global leaderboards, and full Playwright E2E test suite. Built as a Year 3 enterprise software project.',
    tags: ['React.js', 'Node.js', 'MongoDB', 'Socket.IO', 'Playwright'],
    liveLink: 'https://uob-game.netlify.app/',
    githubLink: 'https://github.com/Bijon2002/CIS046-3-Software-For-Enterprise-Project',
    date: '2025 – 2026',
    order: 8
  },
  {
    _id: "p9",
    title: 'HM — Hospital Management System',
    subtitle: 'Full-Stack Application',
    description: 'Modern hospital management system with real-time dashboard, interactive Chart.js visualizations (appointment status, patient demographics, doctor specializations, age analytics), patient/doctor/appointment CRUD, and one-click Excel export. Features gradient design with Material UI.',
    tags: ['React.js', 'Node.js', 'MongoDB', 'Chart.js', 'MUI'],
    githubLink: 'https://github.com/Bijon2002/HM-Hospital-management-System-',
    date: '2025',
    order: 9
  },
  {
    _id: "p10",
    title: 'SMS Spam Classification — NLP',
    subtitle: 'Machine Learning',
    description: 'ML pipeline classifying SMS messages as spam/ham using NLP. Features text preprocessing (tokenization, stemming, stopword removal), TF-IDF feature extraction, and Multinomial Naive Bayes classifier achieving 97.10% accuracy on the UCI dataset.',
    tags: ['Python', 'Scikit-learn', 'NLP', 'TF-IDF', 'ML'],
    githubLink: 'https://github.com/Bijon2002/SMS-Spam-Classification-using-NLP',
    date: '2025',
    order: 10
  },
  {
    _id: "p11",
    title: 'Phone Price Predictor — Neural Network',
    subtitle: 'Deep Learning',
    description: 'Artificial Neural Network predicting mobile phone price ranges (high/low) from 20 hardware specifications. 2-hidden-layer architecture (8→4→1 neurons) with ReLU/Sigmoid activation, achieving 90.20% accuracy on the UCI dataset.',
    tags: ['Python', 'TensorFlow', 'Keras', 'ANN', 'ML'],
    githubLink: 'https://github.com/Bijon2002/phone_price_predictor',
    date: '2025',
    order: 11
  },
  {
    _id: "p12",
    title: 'FastTrack Pro — Courier System',
    subtitle: 'Academic Project',
    description: 'Courier management system with booking, tracking, and Google Maps API integration for ETA calculation and route optimization. Built using modular OOP design with Java Swing.',
    tags: ['Java', 'OOP', 'MySQL', 'Google Maps API'],
    associatedWith: 'SLIIT',
    githubLink: 'https://github.com/Bijon2002/FastTrack',
    date: 'Jun 2025 – Jul 2025',
    order: 12
  },
  {
    _id: "p13",
    title: 'Flagify — Flag Quiz Game',
    subtitle: 'Android App',
    description: 'Fast-paced Android quiz app challenging users to guess 10 random country flags under a 2-minute timer. Built using Java, XML, Firebase, and the REST Countries API.',
    tags: ['Android', 'Java', 'Firebase'],
    associatedWith: 'SLIIT',
    githubLink: 'https://github.com/Bijon2002/Flagify',
    date: 'Jun 2025',
    order: 13
  },
  {
    _id: "p14",
    title: 'SLIIT Moodle — High-Fidelity Design',
    subtitle: 'UI/UX Design',
    description: 'Modern, clean UI redesign for SLIIT Moodle with easy access to courses, notifications, and progress tracking. Uses SLIIT branding, smooth navigation, and real-time updates.',
    tags: ['Figma', 'UI/UX'],
    date: 'May 2025',
    order: 14
  },
  {
    _id: "p15",
    title: 'Medi-Care-Plus',
    subtitle: 'Healthcare System',
    description: 'Healthcare management system for a small facility covering outpatient services, pharmacy management, and appointment scheduling to digitize manual paper records.',
    tags: ['Java', 'API'],
    date: 'Dec 2024 – Jan 2025',
    order: 15
  },
  {
    _id: "p16",
    title: 'AttendanceSystem',
    subtitle: 'Desktop App',
    description: 'Student attendance management app using C# Windows Forms for the front-end, PHP API as the backend, and MySQL database via XAMPP. Supports adding, updating, and tracking student attendance.',
    tags: ['C#', 'PHP', 'MySQL'],
    githubLink: 'https://github.com/Bijon2002/AttendanceSystem',
    order: 16
  },
  {
    _id: "p17",
    title: 'Event Vibe',
    subtitle: 'Event Management',
    description: 'Web application for managing events such as weddings, birthdays, and cultural ceremonies. Users can explore venues and services with 9 event packages available.',
    tags: ['PHP', 'HTML/CSS', 'Web'],
    order: 17
  }
];

export const certifications = [
  { _id: "c-algo", title: 'Merit Award Certificate — CODEFEST 2026 Algothon (Tertiary Category)', issuer: 'SLIIT Faculty of Computing', date: 'Sep 2026', order: -1 },
  { _id: "c-uoj", title: 'UoJ Coders v5.0 Certificate of Participation', issuer: 'University of Jaffna', date: 'Feb 2026', order: -0.5 },
  { _id: "c0", title: 'Kapruka Agent Challenge 2026 Certificate of Participation', issuer: 'Kapruka Holdings PLC', date: 'Feb 2026', order: 0 },
  { _id: "c1", title: 'AI Fluency for Students', issuer: 'Anthropic', date: 'May 2026', order: 1 },
  { _id: "c2", title: 'AI/ML Engineer - Stage 1', issuer: 'SLIIT', date: 'May 2026', order: 2 },
  { _id: "c3", title: 'Claude Code in Action', issuer: 'Anthropic', date: 'May 2026', order: 3 },
  { _id: "c4", title: 'Copado Certified Copado AI', issuer: 'Copado', date: 'Mar 2026', order: 4 },
  { _id: "c5", title: 'AI Fluency Framework & Foundations', issuer: 'Anthropic', date: 'Mar 2026', order: 5 },
  { _id: "c6", title: 'Postman API Fundamentals Student Expert', issuer: 'Postman', date: 'Jan 2026', order: 6 },
  { _id: "c7", title: 'Salesforce Certified AI Associate', issuer: 'Salesforce', date: 'Dec 2024', order: 7 },
  { _id: "c8", title: 'Problem Solving (Basic)', issuer: 'HackerRank', date: 'Jul 2025', order: 8 },
  { _id: "c9", title: 'Introduction to JIRA', issuer: 'Simplilearn', date: 'Jul 2025', order: 9 },
  { _id: "c10", title: 'Web Design for Beginners', issuer: 'University of Moratuwa', date: 'Jun 2025', order: 10 },
  { _id: "c11", title: 'Prompt Engineering 101', issuer: 'KodeKloud', date: 'May 2025', order: 11 },
  { _id: "c12", title: 'eLibraryUSA Online Training', issuer: 'eLibraryUSA', date: 'May 2025', order: 12 },
  { _id: "c13", title: 'C Programming Basics: Flow Control, Variables, and Pointers', issuer: 'LinkedIn', date: 'Apr 2024', order: 13 },
  { _id: "c14", title: 'Introduction to Programming Using Java', issuer: 'Sololearn', date: 'Feb 2025', order: 14 },
  { _id: "c15", title: 'Introduction to C++', issuer: 'Sololearn', date: 'Aug 2024', order: 15 },
  { _id: "c16", title: 'Introduction to Python', issuer: 'Sololearn', date: 'Mar 2024', order: 16 },
  { _id: "c17", title: 'Introduction to HTML', issuer: 'Sololearn', date: 'Aug 2023', order: 17 },
  { _id: "c18", title: 'Git Essential Training', issuer: 'LinkedIn', date: 'Dec 2023', order: 18 },
  { _id: "c19", title: 'Succeeding in Web Development', issuer: 'LinkedIn', date: 'Oct 2023', order: 19 },
  { _id: "c20", title: 'UX Design: 1 Overview', issuer: 'LinkedIn', date: 'Oct 2023', order: 20 }
];

export const competitions = [
  {
    _id: "comp-algothon-2026",
    title: "CODEFEST 2026 – Algothon",
    subtitle: "Tertiary Category · Algorithmic Hackathon",
    year: "2026",
    date: "24 September 2026",
    organizer: "SLIIT (Faculty of Computing)",
    organizerLogo: "/images/codefest2026.png",
    secondaryLogo: "/images/sliit.jpg",
    type: "Group",
    teamName: "CodeMode",
    achievement: "Top 10 + Merit Award",
    awardBadge: "Top 10 · Merit Award",
    isFeatured: true,
    highlight: "Won Merit Award representing SLIIT Northern UNI at Algothon under the Tertiary Category.",
    description: "Competed in the intense Algothon under the Tertiary Category of CODEFEST 2026, organized by the Faculty of Computing, Sri Lanka Institute of Information Technology (SLIIT). Tackled high-difficulty algorithmic challenges, dynamic programming, and data structure optimizations under time pressure, earning a Top 10 finish and the prestigious Merit Award.",
    userStory: "Proud to receive a Merit Award at CODEFEST 2026! Really happy to receive my Merit Award Certificate for representing SLIIT – Northern UNI at Algothon under the Tertiary Category of CODEFEST 2026. This was my first Algothon, and honestly, it was a great experience. From facing challenging problems to trying different approaches under time pressure, every part of the competition pushed me to think differently, stay focused, and keep going when things didn’t go as planned. Getting into the Top 10 and receiving a Merit Award makes this experience even more special. But beyond the certificate, I’m taking away the lessons, the experience, and even more motivation to keep improving. A big thank you to the Faculty of Computing, SLIIT, the CODEFEST 2026 organizing team, and all the sponsors and industry partners for creating such a great platform for students to challenge themselves, compete, and grow. First Algothon. First Merit Award. Definitely not the last.",
    tags: ["Competitive Programming", "Algorithms", "Data Structures", "Problem Solving", "Software Engineering", "Top 10", "Merit Award", "SLIIT Northern UNI"],
    certificate: "/images/algothon/certificate.jpg",
    gallery: [
      {
        id: "algo-cert",
        title: "Merit Certificate",
        image: "/images/algothon/certificate.jpg",
        caption: "Official Merit Award Certificate — CODEFEST 2026 Algothon (Tertiary Category)"
      },
      {
        id: "algo-team",
        title: "Team CodeMode",
        image: "/images/algothon/1790614201301.jpg",
        caption: "Team CodeMode representing SLIIT Northern UNI at CODEFEST 2026 Algothon"
      },
      {
        id: "algo-coding",
        title: "Intense Coding",
        image: "/images/algothon/1790614201417.jpg",
        caption: "Marisilin Bijosilin and team tackling complex algorithmic challenges live"
      },
      {
        id: "algo-arena",
        title: "Contest Arena",
        image: "/images/algothon/1790614200710.jpg",
        caption: "SLIIT Algothon Live Arena & 8-Hour Countdown Display"
      },
      {
        id: "algo-stage",
        title: "Algothon Setup",
        image: "/images/algothon/1790614201065.jpg",
        caption: "SLIIT CODEFEST 2026 Algothon Official Stage"
      }
    ]
  },
  {
    _id: "comp-uoj-5",
    title: "UOJ Coders 5.0",
    subtitle: "Inter-University Competitive Programming",
    year: "2026",
    date: "Feb 2026",
    organizer: "University of Jaffna",
    organizerLogo: "/images/uoj_logo.png",
    type: "Group (Team Lead)",
    teamName: "Team_Git_Force_Push",
    achievement: "Top 10 Finalist",
    awardBadge: "Top 10 Finalist",
    isFeatured: true,
    highlight: "Led Team Git_Force_Push to a Top 10 finish in an intense 12-hour overnight crucible.",
    description: "Led Team Git_Force_Push representing SLIIT Northern UNI at UoJ Coders v5.0 — organized by the Computer Society & Department of Computer Science, University of Jaffna. Competed in an intense 12-hour late-night competitive programming battle alongside 40 top university teams across Sri Lanka.",
    tags: ["Competitive Programming", "Algorithms", "Data Structures", "Team Lead", "University of Jaffna", "Top 10"],
    certificate: "/images/certifi-uoj.jpg",
    gallery: [
      {
        id: "uoj-team",
        title: "Team Photo",
        image: "/images/UOJ1.jpeg",
        caption: "Team Git_Force_Push representing SLIIT Northern UNI at UoJ Coders v5.0"
      },
      {
        id: "uoj-arena",
        title: "Arena",
        image: "/images/UOJ2.jpeg",
        caption: "12-Hour Late-Night Competitive Programming Crucible at University of Jaffna"
      },
      {
        id: "uoj-award",
        title: "Awarding",
        image: "/images/UOJ3.jpeg",
        caption: "UoJ Coders v5.0 Awarding & Recognition Ceremony"
      },
      {
        id: "uoj-cert",
        title: "Certificate",
        image: "/images/certifi-uoj.jpg",
        caption: "UoJ Coders v5.0 Official Certificate of Participation"
      }
    ],
    links: [
      {
        label: "View LinkedIn Post",
        url: "https://www.linkedin.com/posts/marisilin-bijosilin_uojcodersv5-uojcoders-teamgitforcepush-share-7484632746812780544-9LhU"
      }
    ]
  },
  {
    _id: "comp-codestorm-5",
    title: "CODESTORM v5.0",
    subtitle: "Flagship Hackathon & Coding Challenge",
    year: "2026",
    date: "July 2026",
    organizer: "Yarl IT Hub",
    organizerLogo: "/images/yarlithub.png",
    type: "Individual",
    teamName: "Team Bijon",
    achievement: "Finalist",
    awardBadge: "Finalist",
    isFeatured: false,
    highlight: "Qualified as a Finalist for the Grand Finale at YGC Innovation Festival.",
    description: "Competed in CODESTORM v5.0 organized by Yarl IT Hub. Advanced through grueling preliminary problem sets and technical rounds to qualify as a Finalist for the prestigious Grand Finale in July 2026.",
    tags: ["Algorithms", "Problem Solving", "Competitive Programming", "Yarl IT Hub", "Finalist"]
  },
  {
    _id: "comp-hackforce-25",
    title: "Hackforce 25",
    subtitle: "Cloud & Enterprise Hackathon",
    year: "2025",
    date: "2025",
    organizer: "Yarl Salesforce Ohana",
    organizerLogo: "/images/salesforce.png",
    type: "Group",
    teamName: "Drag and Drop",
    achievement: "Selected for Finals",
    awardBadge: "Finalist",
    isFeatured: false,
    highlight: "Qualified into Grand Finals with team 'Drag and Drop' tackling enterprise cloud solutions.",
    description: "Annual hackathon hosted by Yarl Salesforce Ohana engaging developers and cloud enthusiasts. Competed as part of team 'Drag and Drop', designing scalable solutions under time pressure and earning qualification to the Grand Finals.",
    tags: ["Salesforce", "Cloud Solutions", "Enterprise Software", "Team Drag and Drop", "Finalist"]
  },
  {
    _id: "comp-codestorm-ai",
    title: "CODESTORM AI",
    subtitle: "AI Buildathon & Innovation Contest",
    year: "2025",
    date: "Aug 2025",
    organizer: "Yarl IT Hub",
    organizerLogo: "/images/yarlithub.png",
    type: "Individual",
    teamName: "Team Bijon",
    achievement: "Selected for Final Round",
    awardBadge: "Final Round Qualifier",
    isFeatured: false,
    highlight: "Built AI Legal Doc Explainer using NLP to qualify for the Final Round.",
    description: "AI-centric challenge hosted by Yarl IT Hub as part of the YGC Innovation Festival. Developed the 'AI Legal Doc Explainer' — an NLP solution that summarizes legal agreements and identifies risky clauses — qualifying for the Final Round.",
    tags: ["Agentic AI", "NLP", "Machine Learning", "Python", "Legal Tech", "Finalist"]
  },
  {
    _id: "comp-uoj-4",
    title: "UOJ Coders 4.0",
    subtitle: "Competitive Programming Challenge",
    year: "2025",
    date: "2025",
    organizer: "University of Jaffna",
    organizerLogo: "/images/uoj_logo.png",
    type: "Individual",
    teamName: "Team Bijon",
    achievement: "Selected for Finals",
    awardBadge: "Finalist",
    isFeatured: false,
    highlight: "Competed individually as Team Bijon and qualified for the Grand Finals.",
    description: "Flagship competitive programming competition by the Department of Computer Science and Computer Society at University of Jaffna. Solved algorithmic and data structure problems solo as Team Bijon to advance to the Finals.",
    tags: ["Competitive Programming", "C++ / Algorithms", "Problem Solving", "University of Jaffna", "Finalist"]
  },
  {
    _id: "comp-codestorm-2",
    title: "CODESTORM 2.0",
    subtitle: "Speed & Algorithmic Coding Challenge",
    year: "2024",
    date: "3 August 2024",
    organizer: "Yarl IT Hub",
    organizerLogo: "/images/yarlithub.png",
    type: "Individual",
    teamName: "Team Bijon",
    achievement: "Selected for Finals",
    awardBadge: "Finalist",
    isFeatured: false,
    highlight: "Early competitive programming milestone, qualifying for Finals as Team Bijon.",
    description: "The 2.0 edition of Yarl IT Hub's signature coding challenge held on 3 August 2024. Demonstrating speed, algorithm implementation, and mathematical rigor under strict time bounds, successfully qualifying for the Finals.",
    tags: ["Algorithms", "Problem Solving", "Competitive Coding", "Team Bijon", "Finalist"]
  }
];


export const firstClassDegree = {
  degree: "Bachelor of Science with Honours in Software Engineering",
  shortDegree: "BSc (Hons) Software Engineering",
  classification: "First Class Honours",
  awardDate: "5 October 2026",
  awardingBody: "University of Bedfordshire, United Kingdom",
  awardingBodyLogo: "/images/bedfordshire.png",
  collaborativeCampus: "SLIIT Northern UNI, Jaffna",
  collaborativeLogo: "/images/sliit.jpg",
  studentId: "2541518",
  documentImage: "/degree.jpg",
  status: "Completed with Full Award",
  mode: "Full-Time",
  story: {
    title: "From 1st Rank to First Class",
    quote: "During my school years, I achieved 1st rank only once, in Grade 1, Term 1. After that, I never got 1st rank again. More than a decade later, I got my '1st' again. This time, it was First Class. Started with a 1st. Ended with a 1st. That feels pretty special to me.",
    narrative: "Getting here was not always easy. There were difficult semesters, stressful deadlines, challenging projects, research, late nights, and many moments where I questioned myself. But I kept going, and I made it. University was never just about getting a degree. It taught me how to handle pressure, make mistakes, start again, work with people, solve problems, and keep learning.",
    conclusion: "This achievement may have my name on it, but there are so many people behind it. One chapter finished. Now, onto the next one."
  },
  supervisor: {
    name: "Ms. Niroji Thayalan",
    role: "Final-Year Project & Research Supervisor",
    linkedin: "https://www.linkedin.com/in/nirojithayalan/",
    testimonial: "A very special thank you to Ms. Niroji Thayalan, my final-year project supervisor, for guiding me throughout my research and project journey. Your support helped me look beyond simply completing a project and approach my work with more depth and curiosity."
  },
  mentors: [
    { name: "Kanagasabai Thiruthanigesan", linkedin: "https://www.linkedin.com/in/kanagasabai-thiruthanigesan-988a312b0/" },
    { name: "Prof. Sinnathamby Mahesan", linkedin: "https://www.linkedin.com/in/sinnathamby-mahesan-a4a87321/" },
    { name: "Sinthujan V.A.M.R.", linkedin: "https://www.linkedin.com/in/sinthujanr/" },
    { name: "Gowrisha Karuneswaran", linkedin: "https://www.linkedin.com/in/gowrisha-karuneswaran-239845168/" },
    { name: "Vishaliney Pirathap", linkedin: "https://www.linkedin.com/in/vishaliney-pirathap-607121169/" },
    { name: "Sangeetha Arunprakash", linkedin: "https://www.linkedin.com/in/sangeetha-arunprakash-ba7841212/" },
    { name: "Thirukkumaran Shanmugarajah", linkedin: "https://www.linkedin.com/in/thirukkumaran-shanmugarajah-709b52225/" },
    { name: "Vithiyasahar Vigneswaran", linkedin: "https://www.linkedin.com/in/vithiyasahar-vigneswaran-9a160b1a6/" },
    { name: "T. Tharmendra", linkedin: null },
    { name: "Mohamed Aflal", linkedin: "https://www.linkedin.com/in/mohamed-aflal-80b760203/" },
    { name: "Sanduni Mayadunna", linkedin: null },
    { name: "Painthamilan Arumailingam", linkedin: "https://www.linkedin.com/in/arumailingam-painthamilan/" },
    { name: "Aravinth Thevarajan", linkedin: "https://www.linkedin.com/in/aravinth-thevarajan-283a8a125/" },
    { name: "S. Suthagini", linkedin: null },
    { name: "Kithusshand Raveendran", linkedin: "https://www.linkedin.com/in/kithusshand-raveendran-088b371b8/" }
  ],
  seniors: [
    { name: "Anojan Uthayakumar", role: "Senior", linkedin: "https://www.linkedin.com/in/ano2k/" },
    { name: "Renujan Roshan", role: "Senior", linkedin: "https://www.linkedin.com/in/roshan-renujan/" },
    { name: "Paviththanan Ravithas", role: "Senior", linkedin: "https://www.linkedin.com/in/rkpavi/" },
    { name: "Janakan Sakthivel", role: "Senior", linkedin: "https://www.linkedin.com/in/sakthivel-janakan/" },
    { name: "Lambodaran Vinayagamurthi", role: "Senior", linkedin: "https://www.linkedin.com/in/lambodaran/" },
    { name: "Theebiga Vicknarajah", role: "Super Senior", linkedin: "https://www.linkedin.com/in/theebiga-vicknarajah/" }
  ]
};

export const education = [
  {
    _id: "edu1",
    degree: "BSc (Hons) in Software Engineering — First Class Honours",
    institution: "University of Bedfordshire, United Kingdom",
    affiliatedVia: "Awarded via SLIIT Northern UNI, Jaffna",
    campus: "SLIIT Northern University — Jaffna",
    logo: "/images/bedfordshire.png",
    secondaryLogo: "/images/sliit.jpg",
    period: "2025 — 2026 (Awarded: 5 Oct 2026)",
    status: "Completed with Full Award (First Class Honours)",
    isFirstClass: true,
    description: "Officially completed and awarded First Class Honours in BSc (Hons) Software Engineering by the University of Bedfordshire, United Kingdom in collaboration with SLIIT Northern UNI, Jaffna. Successfully completed all requirements under full-time attendance.",
    achievements: [
      "Award: Bachelor of Science with Honours in Software Engineering (Classification: First Class Honours).",
      "Award Date: 5 October 2026 · Student ID: 2541518 · Registration Status: Completed with full award.",
      "Enterprise Software Project: Banana Brain Quest — real-time multiplayer math game with Socket.IO, XP ranking system, and Playwright E2E testing suite.",
      "Advanced modules in distributed software architecture, enterprise web systems, and project management."
    ]
  },
  {
    _id: "edu2",
    degree: "BSc (Hons) in Software Engineering",
    institution: "Sri Lanka Institute of Information Technology (SLIIT)",
    campus: "SLIIT Northern University — Jaffna / Kilinochchi Campus",
    logo: "/images/uni.png",
    secondaryLogo: "/images/sliit.jpg",
    period: "2023 — 2026",
    status: "Completed (First Class Pathway)",
    description: "Comprehensive undergraduate engineering journey at SLIIT Northern University focusing on full-stack development, AI integration, and scalable system architecture. SLIIT is Sri Lanka's premier degree-awarding institute.",
    achievements: [
      "Final-Year Research: Uncertainty-Aware ECG Arrhythmia Detection using CNN ensemble models with MC Dropout uncertainty quantification (MIT-BIH Database, 97.4% F1 score, Streamlit deployment).",
      "Engineered multiple production-grade software applications using React, Node.js, Express, Laravel, Spring Boot, and FastAPI.",
      "Elected Committee Member — Student Union, SLIIT Northern University.",
      "Selected for the prestigious SLIIT Northern UNI International Student Mobility Programme to SIMATS Saveetha University, Chennai, India."
    ]
  },
  {
    _id: "edu3",
    degree: "BSc Computer Science (Info School Program)",
    institution: "Informatics Institute of Technology (IIT Campus)",
    period: "Jan 2023 — May 2024",
    logo: "/images/iit.png",
    description: "Foundation year program at IIT Campus, Sri Lanka before transferring to SLIIT for the full BSc Software Engineering degree. Gained foundational programming, mathematics, and computer science skills.",
    achievements: [
      "Completed foundational modules in programming, algorithms, mathematics, and computer science principles."
    ]
  },
  {
    _id: "edu4",
    degree: "G.C.E. O/L & A/L (Bio Stream)",
    institution: "St. John's College, Jaffna",
    period: "2013 — 2022",
    logo: "/images/school.png",
    description: "Completed Advanced Level (Bio Stream) and Ordinary Level examinations at St. John's College, one of Jaffna's most historic and prestigious collegiate institutions.",
    achievements: [
      "Vice Captain — House (Handy).",
      "President — Catholic Union."
    ]
  }
];

export const experiences = [
  {
    _id: "e0",
    role: 'Junior Software Engineer',
    organization: 'WECONN3CT GmbH',
    logo: '/images/weconnect.png',
    employmentType: 'Full-time',
    description: 'Serving as a Full-Time Remote Junior Software Engineer at WECONN3CT GmbH, based in Bad Honnef am Rhein, North Rhine-Westphalia, Germany. Engineering scalable backend microservices, high-performance web applications, robust RESTful APIs, and implementing automated testing & CI/CD workflows for enterprise platforms.',
    type: 'Professional Experience',
    date: 'Aug 2026 – Present',
    location: 'Bad Honnef am Rhein, North Rhine-Westphalia, Germany · Remote',
    order: 0
  },
  {
    _id: "e1",
    role: 'Software Engineer Intern',
    organization: 'FAITE Pvt Ltd',
    logo: '/images/faite.jpg',
    employmentType: 'Internship',
    description: 'Contributed to NPRPTA (rpta.np.gov.lk) — a live government bus permit management system serving 5 administrative districts with 8 role-based user types, covering permit issuance, multi-level approvals, fine calculation, invoice generation, and expiry validation. Contributed to an AI Marketing Tool, integrating ML model features for campaign generation, sentiment analysis, real-time behaviour tracking, dynamic pricing, CLV prediction, and social media automation via Ayrshare and Gemini APIs. Contributed to Development Connect (developmentconnect.com) — a platform for a Sri Lankan NGO enabling professionals to post opportunities and development news. Improved admin panel UI for Vivaha Matrimony (vivahamatrimony.com) including profile verification, success stories management, and user dashboards.',
    type: 'Professional Experience',
    date: 'Feb 2026 – Present',
    location: 'Jaffna, Sri Lanka',
    order: 1
  },
  {
    _id: "e2",
    role: 'Intern Software Engineer',
    organization: 'CodeVita (Pvt) Ltd',
    logo: '/images/codevita.jpg',
    description: 'Contributed to Offero.lk — a multi-category classified ads platform covering properties, vehicles, and events using Laravel and MySQL. Enhanced Arul Global Express admin panel with location suggestion, dynamic category features, and UI improvements using Laravel Blade. Contributed to Apini Market POS system covering stock shortage handling, delivery note workflow, and inventory management.',
    type: 'Professional Experience',
    date: 'Jul 2025 – Dec 2025',
    location: 'Remote',
    order: 2
  },
  {
    _id: "e3",
    role: 'BSc (Hons) Software Engineering',
    organization: 'SLIIT',
    description: 'Final-year undergraduate. Expected graduation 2027.',
    type: 'Education',
    date: 'Mar 2024 – Present',
    order: 3
  },
  {
    _id: "e4",
    role: 'BSc Computer Science',
    organization: 'Informatics Institute of Technology (IIT Campus)',
    description: 'Attended Info School Program 2023.',
    type: 'Education',
    date: 'Jan 2023 – May 2024',
    order: 4
  },
  {
    _id: "e5",
    role: 'G.C.E. O/L & A/L (Bio Stream)',
    organization: "St. John's College, Jaffna",
    description: 'Vice Captain — House (Handy). President — Catholic Union.',
    type: 'Education',
    date: 'Jan 2013 – Feb 2022',
    order: 5
  },
  {
    _id: "e6",
    role: 'Board of Directors',
    organization: 'Rotaract Club Of Chunnakam',
    logo: '/images/rotrarct.png',
    description: 'Providing strategic leadership to foster youth empowerment and drive impactful community service initiatives. Actively mentoring members, managing club operations, and cultivating partnerships for sustainable social development projects.',
    type: 'Volunteering & Leadership',
    date: 'Present',
    order: 6
  },
  {
    _id: "e7",
    role: 'Knowledge Sharing Session — "The Eyes of AI"',
    organization: 'AppZ Makers',
    description: 'Delivered a knowledge-sharing session on "The Eyes of AI — A Beginner\'s Journey into CNN", covering how Convolutional Neural Networks enable computers to interpret images — from face recognition and Google Lens to healthcare and autonomous vehicles.',
    type: 'Sessions & Talks',
    date: 'June 2, 2026',
    image: '/images/session.jpg',
    videos: [
      'https://www.youtube.com/embed/hxpWl6kG4_c'
    ],
    order: 6.5
  },
  {
    _id: "e8",
    role: 'Committee Member',
    organization: 'Yarl Salesforce Ohana',
    logo: '/images/salesforce.png',
    description: 'Played a key role in the organizing committee for Yarl Dreamin\' 2025, a premier community-led tech conference. Collaborated with industry professionals to bring together Salesforce Trailblazers, facilitating technical networking, knowledge-sharing, and skill development.',
    type: 'Volunteering & Leadership',
    date: 'Jan 2025 – Jan 2026',
    order: 7
  },
  {
    _id: "e9",
    role: 'Committee Member',
    organization: 'Student Union, SLIIT Northern Uni',
    logo: '/images/sliit.jpg',
    description: 'Elected to represent the student body, advocating for student welfare and bridging communication between the administration and students. Organized major university events, workshops, and extracurricular activities to enhance the campus experience and foster a vibrant academic culture.',
    type: 'Volunteering & Leadership',
    date: 'Sep 2024 – Jan 2026',
    order: 8
  },
  {
    _id: "e10",
    role: 'Sergeant-at-Arms (SAA)',
    organization: 'Rotaract Club Of Chunnakam',
    logo: '/images/rotrarct.png',
    description: 'Ensured smooth execution of official meetings and major community service events by managing logistics, venue setup, and protocol enforcement. Maintained decorum and discipline within the club while fostering a welcoming environment for members and guests.',
    type: 'Volunteering & Leadership',
    date: 'Jun 2024 – Jun 2025',
    order: 9
  },
  {
    _id: "e11",
    role: 'Committee Member',
    organization: 'Sirakukal Amayam',
    logo: '/images/sirakugal.jpg',
    description: 'Dedicated to grassroots community service and social upliftment through active volunteering. Coordinated charitable drives, assisted vulnerable groups, and helped organize community outreach programs focused on education and essential support.',
    type: 'Volunteering & Leadership',
    date: 'Jan 2025 – Present',
    order: 10
  }
];
